import React from "react";
import AboutUsCard from "../Card/AboutUsCard";
import bgAboutUs from "../../assets/bgabout.png";
import gdeskGee from "../../assets/gdeskgee.png";
import AboutGDesk from "../Card/AboutGDeskContent";
import { motion } from "framer-motion";

const AboutUs = () => {
  return (
    <div
      id="about"
      className="bg-[#FFE3E3] text-primary px-1 pt-5 lg:px-10"
      style={{
        backgroundImage: `url(${bgAboutUs})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <motion.h1
        className="font-bold text-4xl text-center md:pt-8 pt-5 pb-20"
        initial={{ opacity: 0, y: -40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        About Us
      </motion.h1>

      <motion.div
        className="md:m-0 md:px-2 lg:ml-4 grid lg:grid-cols-2"
        initial={{ opacity: 0, y: -40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.8 }}
        viewport={{ once: true }}
      >
        <AboutUsCard
          title={"Vision"}
          firstcontent={
            "We envision a future where businesses operate with clarity, efficiency, and confidence, no longer constrained by disorganization or limited capacity. Through purposeful placement and thoughtful support, the right people enable work to flow seamlessly, scale sustainably, and succeed with intention behind the scenes."
          }
          secondcontent={
            "At the same time, we aspire to cultivate a community of virtual professionals who are empowered, continuously developing, and recognized for the value they bring, elevating the standard of remote work across industries."
          }
        />

        <AboutUsCard
          title={"Mission"}
          firstcontent={
            "We bring structure, clarity, and efficiency to growing businesses through intelligent support systems and highly capable virtual professionals. We go beyond task execution by placing individuals who think critically, adapt quickly, and contribute meaningfully to operational success."
          }
          secondcontent={
            "At the same time, we are committed to empowering virtual assistants by providing opportunities for growth, continuous development, and purposeful work—equipping them to perform with confidence, professionalism, and long-term value."
          }
        />
      </motion.div>

      <div className="grid xl:grid-cols-2 m-5 mt-0 mb-0">
        <motion.div
          className="lg:pt-10"
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1.8 }}
          viewport={{ once: true }}
        >
          <div className="my-5 pt-10 xl:mb-5 lg:order-1 bg-white/50 rounded-lg p-8 lg:pt-6 px-2 lg:px-6">
            <h1 className="text-4xl font-semibold text-center pt-5 pb-8 md:py-5">
              About GDesk
            </h1>
            <AboutGDesk
              firstcontent={
                "GDesk was founded with a focused mission: to provide reliable and highly skilled medical virtual assistants who could support healthcare professionals with precision, confidentiality, and efficiency. What began as a specialized service in the medical field quickly earned trust through consistent performance and attention to detail. "
              }
              seccontent={
                "As client needs evolved, so did GDesk. The company expanded its services to include social media management and internal campaign support, helping businesses strengthen their online presence and streamline communication strategies. This natural progression allowed GDesk to support not only operations but also brand growth. "
              }
              thirdcontent={
                "Building on this foundation, GDesk further broadened its capabilities to include customer service and general virtual assistance. Today, GDesk delivers well-rounded support solutions across multiple industries, combining structured systems, skilled professionals, and a commitment to excellence."
              }
            />
          </div>
        </motion.div>
        <motion.div
          className="p-0 m-0 lg:order-2"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1.8 }}
          viewport={{ once: true }}
        >
          <img
            src={gdeskGee}
            alt="Gee for About Us"
            className="hidden xl:block h-full w-auto object-contain rounded-lg drop-shadow-lg hover:drop-shadow-xl transition-all duration-300"
          />
        </motion.div>
      </div>
    </div>
  );
};

export default AboutUs;
